import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import AddIcon from '@material-ui/icons/AddBoxOutlined'

const style = theme => ({
	root: {

	}
})

function AddButton({
	classes,
	children,
	...others
}) {
	
	return (
		<Button
			Icon={AddIcon}
			variant='text'
			{...others}
		>
			{children}
		</Button>
	)
}

AddButton.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(AddButton);